var render = function render(){var _vm=this,_c=_vm._self._c;return _c('email-editor',{ref:"emailEditor",staticClass:"h-0 min-h-md h-screen-75 border border-gray-300 rounded-sm bg-gray-200",attrs:{"locale":`${_vm.$i18n.locale}-CA`,"project-id":_vm.projectId,"options":_vm.emailEditorOptions},on:{"load":_vm.editorLoaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }